import React from 'react';
import { FaEye, FaBullseye, FaHeart } from 'react-icons/fa';

const AboutMissionVision = ({ language }) => {
  return (
    <section className="py-5 bg-white" id="mission-vision">
      <div className="container">
<h2 className="text-center fw-bold mb-5">
  {language === 'en' 
    ? 'Our Vision, Mission & Core Values' 
    : 'የእኛ ራዕይ፣ ተልእኮ እና መሠረታዊ እሴቶች'}
</h2>
        <div className="row text-center" data-aos="fade-up">

          <div className="col-md-4 mb-4">
            <FaEye size={40} className="text-primary mb-3" />
            <h5 className="fw-bold">
      {language === 'en' ? 'Vision' : 'ራዕይ'}
    </h5>
    <p>
      {language === 'en' 
        ? 'Providing sustained quality service to our customer and guest.'
        : 'ለደንበኞቻችን እና ለእንግዳችን ዘላቂ ጥራት ያለው አገልግሎት መስጠት።።'
      }
    </p>

          </div>

          <div className="col-md-4 mb-4">
            <FaBullseye size={40} className="text-success mb-3" />
           <h5 className="fw-bold">
      {language === 'en' ? 'Mission' : 'ተልእኮ'}
    </h5>
    <p>
      {language === 'en' 
        ? 'Getting customer satisfaction by maximizing focus and quality services .A club with a mission to be first choose as a hotel in our services and accommodations there by exceeding the expectation of our customers, employees, shareholders and the community'
        : 'ትኩረትን እና ጥራት ያላቸውን አገልግሎቶችን ከፍ በማድረግ የደንበኞችን እርካታ ማግኘት። ተልእኮ ያለው ክለብ ደንበኞቻችን፣ሰራተኞቻችን፣ባለአክሲዮኖቻችን እና ማህበረሰቡ ከሚጠበቀው በላይ በማድረግ በአገልግሎታችን እና በእዚያ ማደሪያ ውስጥ እንደ ሆቴል የመምረጥ ተልእኮ ያለው ክለብ ነው።።'
      }
    </p>
    
          </div>

          <div className="col-md-4 mb-4">
            <FaHeart size={40} className="text-danger mb-3" />
 <h5 className="fw-bold">
      {language === 'en' ? 'Core Values' : 'መሠረታዊ እሴቶች'}
    </h5>
    <p>
      {language === 'en' 
        ? 'Customer satisfaction, Employees empowerment, Corporate identity and image, Integrity and Ethics, Quality and excellence, Team work and cooperation, Competing in hotel industry service and customer flow, Profit and growth, Respect and trust ,Strength and stability.'
        : 'የደንበኛ እርካታ ፣ የሰራተኞች ማጎለበት ፣ የድርጅት መለያ እና ምስል መጠበቅ እና ማሳደግ ፣ ታማኝነት እና ስነምግባር ፣ ጥራት እና ልህቀት ፣ የቡድን ስራ እና ትብብር ፣ በሆቴል ኢንዱስትሪ አገልግሎት እና የደንበኛ ፍሰት ውስጥ ተወዳዳሪ መሆን ፣ ትርፍ እና እድገት ፣ አክብሮት እና እምነት ፣ ጥንካሬ እና መረጋጋት።'
      }
    </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutMissionVision;

